module.exports = __webpack_public_path__ + "img/black-bin.7bda2772.svg";